import { useCallback, useState } from 'react'
import { LatLng, PositionType } from '../types/geofence.type'

export const usePolygon = (initialPoints?: PositionType[]) => {
    const [points, setPoints] = useState<PositionType[]>(initialPoints ?? [])

    const addPoint = useCallback(
        (coords: LatLng) => {
            const existpoints = [...points]
            existpoints.push({ ...coords, order: existpoints.length })
            setPoints(existpoints)
        },
        [points]
    )

    const removeLastPoint = useCallback(() => {
        const existpoints = [...points]
        existpoints.pop()
        setPoints(existpoints)
    }, [points])

    const updatePoint = useCallback(
        (index: number, position: LatLng) => {
            const existpoints = [...points]
            const point = { ...existpoints[index] }
            point.latitude = position.latitude
            point.longitude = position.longitude
            existpoints[index] = point
            setPoints(existpoints)
        },
        [points]
    )

    const deletePoint = useCallback(
        (index: number) => {
            const existpoints = [...points]
            existpoints.splice(index, 1)
            setPoints(existpoints)
        },
        [points]
    )

    return {
        points,
        addPoint,
        removeLastPoint,
        updatePoint,
        deletePoint,
    }
}
